import { CIcon } from '~/icons/types'
export const ciSavedSearch: CIcon = {
  name: 'saved-search',
  type: 'light',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19.5 13.25a.75.75 0 0 0-.75.75v5.787l-6.415-3.207a.752.752 0 0 0-.67 0L5.25 19.787V5.507c0-.739.534-1.357 1.243-1.439a47.282 47.282 0 0 1 3.792-.287.75.75 0 0 0-.053-1.499 49.32 49.32 0 0 0-3.912.296c-1.465.17-2.57 1.43-2.57 2.93V21a.75.75 0 0 0 1.085.671L12 18.09l7.165 3.582a.746.746 0 0 0 .73-.034.752.752 0 0 0 .355-.638v-7a.75.75 0 0 0-.75-.75Z'
    },
    {
      d:
        'm21.53 10.47-1.827-1.828a4.054 4.054 0 0 0 .714-2.309 4.088 4.088 0 0 0-4.084-4.083 4.088 4.088 0 0 0-4.083 4.083 4.088 4.088 0 0 0 6.392 3.369l1.828 1.828a.748.748 0 0 0 1.06 0 .749.749 0 0 0 0-1.06Zm-3.37-2.31a2.566 2.566 0 0 1-1.827.756 2.586 2.586 0 0 1-2.583-2.583 2.586 2.586 0 0 1 2.583-2.583 2.586 2.586 0 0 1 2.584 2.583c0 .69-.269 1.339-.757 1.827Z'
    }
  ]
}
